import { createRoute } from '@tanstack/react-router'
import { useAuthStore } from '@/application/stores/auth.store'
import { useGetMe } from '@/application/services/user.service'
import { Skeleton } from '@/ui/components/common/Skeleton'
import { managementLayoutRoute } from '@/ui/pages/management'
import { ProfileInfoSection } from './components/ProfileInfoSection'
import { TwoFASection } from './components/TwoFASection'
import { DangerZoneSection } from './components/DangerZoneSection'

export const profileRoute = createRoute({
  getParentRoute: () => managementLayoutRoute,
  path: 'profile',
  component: ProfilePage,
})

/**
 * Profile management page. Shows the loading skeleton while the current user
 * is being fetched, then composes the editable info, 2FA, and danger-zone
 * sections. 2FA is only rendered for password accounts and the danger zone
 * is hidden for streamer accounts.
 */
export function ProfilePage() {
  const { user } = useAuthStore()
  const { data: profile, isLoading } = useGetMe()

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-40 w-full" />
      </div>
    )
  }

  const role = profile?.role ?? user?.role
  const showDangerZone = role !== 'streamer'

  return (
    <div className="space-y-6">
      <ProfileInfoSection />

      {profile?.hasPassword && (
        <TwoFASection twoFactorEnabled={profile?.twoFactorEnabled ?? false} />
      )}

      {showDangerZone && <DangerZoneSection />}
    </div>
  )
}
